import { render, staticRenderFns } from "./ModalJustificativaRestricoes.vue?vue&type=template&id=e3e7197a&lang=pug"
import script from "./ModalJustificativaRestricoes.vue?vue&type=script&lang=js"
export * from "./ModalJustificativaRestricoes.vue?vue&type=script&lang=js"
import style0 from "./ModalJustificativaRestricoes.vue?vue&type=style&index=0&id=e3e7197a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports